<template>
  <div class="row">
    <div class="col-md-6 mb-3">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="card-body p-15 p-sm-20 p-md-25">
          <vue-good-table
            :columns="columns"
            :rows="rows1"
            :search-options="{
              enabled: true,
              externalQuery: searchTerm,
            }"
            :pagination-options="{
              enabled: true,
              perPage: pageLength,
            }"
          >
            <template #emptystate>
              <center>Aucune entrées correspondants trouvés</center>
            </template>
            <template #table-row="props">
              <span v-if="props.column.field === 'action'">
                <template v-if="auth.can('SETTINGS')">
                  <button
                    class="btn btn-success btn-sm"
                    @click="AddCity(props.row.id)"
                    title="Ajouter Ville"
                  >
                    <i class="flaticon-plus"></i>
                  </button>
                </template>
              </span>

              <!-- Column: Common -->
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>

            <!-- pagination -->
           <template #pagination-bottom="props">
                <div class="d-flex justify-content-between flex-wrap align-items-center">
                    <!-- Per Page Selector -->
                    <div class="d-flex align-items-center mb-2">
                    <span class="me-2">Showing 1 to</span>
                    <select
                        class="form-select form-select-sm me-2"
                        v-model="pageLength"
                        @change="(e) => props.perPageChanged({ currentPerPage: Number(e.target.value) })"
                        style="width: auto;"
                    >
                        <option v-for="opt in ['10','25','50','100']" :key="opt" :value="opt">
                        {{ opt }}
                        </option>
                    </select>
                    <span>of {{ props.total }} entries</span>
                    </div>

                    <!-- Pagination -->
                    <nav>
                    <ul class="pagination mb-0">
                        <!-- First Page -->
                        <li 
                        class="page-item" 
                        :class="{ disabled: props.currentPage === 1 }"
                        >
                        <a 
                            class="page-link" 
                            href="#" 
                            @click.prevent="props.pageChanged({ currentPage: 1 })"
                        >
                            First
                        </a>
                        </li>

                        <!-- Previous -->
                        <li 
                        class="page-item" 
                        :class="{ disabled: props.currentPage === 1 }"
                        >
                        <a 
                            class="page-link" 
                            href="#" 
                            @click.prevent="props.pageChanged({ currentPage: props.currentPage - 1 })"
                        >
                            <i class="flaticon-chevron-1"></i>
                        </a>
                        </li>

                        <!-- Page Numbers -->
                        <li 
                        class="page-item" 
                        v-for="page in Math.ceil(props.total / pageLength)" 
                        :key="page"
                        :class="{ active: page === props.currentPage }"
                        >
                        <a 
                            class="page-link" 
                            href="#" 
                            @click.prevent="props.pageChanged({ currentPage: page })"
                        >
                            {{ page }}
                        </a>
                        </li>

                        <!-- Next -->
                        <li 
                        class="page-item" 
                        :class="{ disabled: props.currentPage === Math.ceil(props.total / pageLength) }"
                        >
                        <a 
                            class="page-link" 
                            href="#" 
                            @click.prevent="props.pageChanged({ currentPage: props.currentPage + 1 })"
                        >
                            <i class="flaticon-chevron"></i>
                        </a>
                        </li>

                        <!-- Last Page -->
                        <li 
                        class="page-item" 
                        :class="{ disabled: props.currentPage === Math.ceil(props.total / pageLength) }"
                        >
                        <a 
                            class="page-link" 
                            href="#" 
                            @click.prevent="props.pageChanged({ currentPage: Math.ceil(props.total / pageLength) })"
                        >
                            Last
                        </a>
                        </li>
                    </ul>
                    </nav>
                </div>
            </template>

          </vue-good-table>
        </div>
      </div>
    </div>

    <div class="col-md-6 mb-3">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="card-body p-15 p-sm-20 p-md-25">
          <vue-good-table
            :columns="columns"
            :rows="rows2"
            :search-options="{
              enabled: true,
              externalQuery: searchTerm,
            }"
            :pagination-options="{
              enabled: true,
              perPage: pageLength,
            }"
          >
            <template #emptystate>
              <center>Aucune entrées correspondants trouvés</center>
            </template>
            <template #table-row="props">
              <span v-if="props.column.field === 'action'">
                <template v-if="auth.can('SETTINGS')">
                  <button
                    class="btn btn-danger btn-sm"
                    @click="RemoveCity(props.row.id)"
                    title="Supprimer Ville"
                  >
                    <i class="flaticon-delete"></i>
                  </button>
                </template>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>

            <!-- pagination -->
            <template #pagination-bottom="props">
              <div
                class="d-flex justify-content-between flex-wrap align-items-center"
              >
                <!-- Per Page Selector -->
                <div class="d-flex align-items-center mb-2">
                  <span class="me-2">Showing 1 to</span>
                  <select
                    class="form-select form-select-sm me-2"
                    v-model="pageLength"
                    @change="
                      (e) =>
                        props.perPageChanged({
                          currentPerPage: Number(e.target.value),
                        })
                    "
                    style="width: auto"
                  >
                    <option
                      v-for="opt in ['10', '25', '50', '100']"
                      :key="opt"
                      :value="opt"
                    >
                      {{ opt }}
                    </option>
                  </select>
                  <span>of {{ props.total }} entries</span>
                </div>

                <!-- Pagination -->
                <nav>
                  <ul class="pagination mb-0">
                    <!-- Previous -->
                    <li
                      class="page-item"
                      :class="{ disabled: props.currentPage === 1 }"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="
                          props.pageChanged({
                            currentPage: props.currentPage - 1,
                          })
                        "
                      >
                        <i class="flaticon-chevron-1"></i>
                      </a>
                    </li>

                    <!-- Page Numbers -->
                    <li
                      class="page-item"
                      v-for="page in Math.ceil(props.total / pageLength)"
                      :key="page"
                      :class="{ active: page === props.currentPage }"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="
                          props.pageChanged({ currentPage: page })
                        "
                      >
                        {{ page }}
                      </a>
                    </li>

                    <!-- Next -->
                    <li
                      class="page-item"
                      :class="{
                        disabled:
                          props.currentPage ===
                          Math.ceil(props.total / pageLength),
                      }"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="
                          props.pageChanged({
                            currentPage: props.currentPage + 1,
                          })
                        "
                      >
                        <i class="flaticon-chevron"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
              </template>
        </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import { useRoute } from "vue-router";
import api from "@/utils/axios";

export default defineComponent({

    props: {
    id: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const route = useRoute();
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const pageLength = 10;
    const columns = [
      {
        label: "Ville",
        field: "name",
        filterOptions: {
          enabled: true,
          placeholder: "Filtrer Ville",
        },
      },
      {
        label: "Actions",
        field: "action",
      },
    ];
    const rows1 = ref([]);
    const rows2 = ref([]);
    const searchTerm = ref("");

    function RemoveCity(id) {
      let data = new FormData;
        data.append('city_id', id);
        data.append('zone_id', String(route.params.id));
        api.post(`/api/auth/remove_city_zone`, data)
        .then((res: any) => {
          if (res.data.message === 'success') {
            GetZones();
            showToast('Vos données sont bien enregistrés', 'success');
          } else if (res.data.message === 'no city') {
            showToast('Erreur ville n\'existe pas', 'error');
          } else if (res.data.message === 'no zone') {
            showToast('Erreur zone n\'existe pas', 'error');
          }
        })
        .catch(() => {
          showToast('Something went wrong! Please try again', 'error');
        })
    }
    function AddCity(id: string) {
      let data = new FormData();
      data.append('city_id', id);
      data.append('zone_id', String(route.params.id));
      api.post(`/api/auth/add_city_zone`, data)
        .then((res: { data: { message: string } }) => {
          if (res.data.message === 'success') {
            GetZones();
            showToast('Vos données sont bien enregistrés', 'success');
          } else if (res.data.message === 'no city') {
            showToast('Erreur ville n\'existe pas', 'error');
          } else if (res.data.message === 'no zone') {
            showToast('Erreur zone n\'existe pas', 'error');
          }
        })
        .catch(() => {
          showToast('Something went wrong! Please try again', 'error');
        });
    }
    async function GetZones() {
      // Fetch zones from API and populate rows1 and rows2
      try {
        const res = await api.get(`/api/auth/citiesNoZone`);
        rows1.value = res.data.data;
      } catch (error) {
        showToast("Erreur lors de la récupération des villes", "error");
      }

      try {
        const res = await api.get(`/api/auth/zone_cities/${route.params.id}`);
        rows2.value = res.data.data;
      } catch (error) {
        showToast("Erreur lors de la récupération des villes", "error");
      }
    }

     onMounted(async () => {
       await GetZones();
     });
    return {
      auth,
      columns,
      rows1,
      rows2,
      pageLength,
      searchTerm,
      RemoveCity,
      AddCity,
    };
  },
});
</script>
